<div [formGroup]="subscriptionForm">
  <div class="px-2 pt-2">
    <div class="form-row row">
      <label class="col-3 col-lg-2 control-label required">{{'i18n.domain.administration.subscription-details.general-tab.name' | translate}}:</label>
      <div class="col-9 col-lg-4">
        <input type="text"
              formControlName="name"
              class="form-control">
        <app-error-messages [control]="subscriptionForm.controls.name"></app-error-messages>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.active' | translate}}:</label>

      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="active"
                                formControlName="active">
        </app-yes-no-group-button>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 control-label">{{'i18n.domain.administration.subscription-details.general-tab.description' | translate}}:</label>
      <div class="col-9 col-lg-10">
        <textarea
              rows="3"
              formControlName="description"
              class="form-control"></textarea>
        <app-error-messages [control]="subscriptionForm.controls.description"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label
        class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.assignable' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="assignable"
                                formControlName="assignable">
        </app-yes-no-group-button>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.session-extendable' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="sessionIsExtendable"
                                formControlName="sessionIsExtendable">
        </app-yes-no-group-button>
      </div>
    </div>
    <div class="form-row row">
      <label for="companyId" class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.company' | translate }}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <ejs-dropdownlist [dataSource]="data" [fields]="dropdownSettings" [showClearButton]="true"
          id="companyId" formControlName="companyId">
        </ejs-dropdownlist>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.type' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group id="type"
                          [fieldsEnum]="ParkingSubscriptionType"
                          formControlName="type"
                          [translateKey]="'i18n.domain.administration.subscription-details.general-tab.type-enum.'"></app-button-group>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.denyForeignParkingSubscriptionFallback' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="denyForeignParkingSubscriptionFallback"
                                formControlName="denyForeignParkingSubscriptionFallback">
        </app-yes-no-group-button>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.usage' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group id="usage"
                          [fieldsEnum]="Usage"
                          formControlName="usage"
                          [translateKey]="'i18n.domain.administration.subscription-details.general-tab.type-usage.'"></app-button-group>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.paid-by' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group id="paidBy"
                          [fieldsEnum]="PaidBy"
                          formControlName="paidBy"
                          [translateKey]="'i18n.domain.administration.subscription-details.general-tab.type-paid-by.'"></app-button-group>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.parking-card-confirmation-time' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format="n" decimals="0" formControlName="pcConfirmTime" name='pcConfirmTime' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">{{' min'}}</span>
        <app-error-messages [control]="subscriptionForm.controls.pcConfirmTime"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.simultaneous-vehicles-apply' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group [fieldsEnum]="MultipleCarsPerUserTreatAs"
                          id="role"
                          formControlName="multipleCarsPerUserTreatAs"
                          [translateKey]="'i18n.shared.multiple-cars-per-user-treat-as.'"></app-button-group>
      </div>

      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.shared.fields.tariff-currency' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group [fieldsEnum]="CurrencyEnum"
                          id="currency"
                          formControlName="currency"
                          [translateKey]="'i18n.shared.currencies.'"></app-button-group>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.max-parking-duration' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-multi-field-duration-picker [form]="subscriptionForm.controls.maxParkingDurationInMinForm"></app-multi-field-duration-picker>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label"
            [ngClass]="'required'">
        {{'i18n.domain.administration.subscription-details.general-tab.roundTo' | translate}}:
      </label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format="n" decimals="0" formControlName="roundSessionFeeToXCents" name='roundSessionFeeToXCents' validateDecimalOnType="true" min="1"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencyCents.' + CurrencyCentsEnum[subscriptionForm.controls.currency.value] | translate}}</span>
        <app-error-messages [control]="subscriptionForm.controls.roundSessionFeeToXCents"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.parking-quota-value' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format="n" decimals="0" formControlName="parkingQuotaHours" name='parkingQuotaHours' validateDecimalOnType="true" min="1"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">h</span>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.parking-quota-duration' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-button-group [fieldsEnum]="QuotaDuration"
                          id="parkingQuotaDuration"
                          formControlName="parkingQuotaDuration"
                          [translateKey]="'i18n.shared.parkingQuotaDuration.'"></app-button-group>
      </div>
    </div>
  </div>

  <div class="px-2 topLine">
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.employment-percentage' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="chargeInRelationToEmploymentPercentage"
                                formControlName="chargeInRelationToEmploymentPercentage"></app-yes-no-group-button>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.cap-per-month' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0">
        <app-yes-no-group-button id="chargeCapPerMonth"
                                  formControlName="chargeCapPerMonth"></app-yes-no-group-button>
      </div>
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label"
            [ngClass]="{'required': subscriptionForm.controls.chargeCapPerMonth.value}">
        {{'i18n.domain.administration.subscription-details.general-tab.cap' | translate}}:
      </label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format='n2' decimals="2" formControlName="chargeCap" name='chargeCap' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[subscriptionForm.controls.currency.value] | translate}}</span>
        <app-error-messages [control]="subscriptionForm.controls.chargeCap"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.fixed-price-per-month' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format='n2' decimals="2" formControlName="fixPricePerMonth" name='fixPricePerMonth' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[subscriptionForm.controls.currency.value] | translate}}</span>
        <app-error-messages [control]="subscriptionForm.controls.fixPricePerMonth"></app-error-messages>
      </div>
    </div>
  </div>

  <div class="px-2 topLine">
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.subscription-details.general-tab.modified-by' | translate}}:</label>
      <div class="col-10 col-lg-4 align-items-center">
          <div>{{subscriptionForm.controls.modifiedBy.value}}</div>
      </div>
    </div>
      <div class="form-row row">
        <label class="col-2 control-label">{{'i18n.domain.administration.subscription-details.general-tab.modified-on' | translate}}:</label>
        <div class="col-10 col-lg-4 align-items-center">
            <div>{{subscriptionForm.controls.modifiedOn.value}}</div>
      </div>
    </div>
  </div>
  <!-- <div class="px-2 topLine">
    <div class="form-row row">
      <label class="col-3 col-lg-2 mt-3 mt-lg-0 control-label">{{'i18n.domain.administration.subscription-details.general-tab.base-price-per-day' | translate}}:</label>
      <div class="col-9 col-lg-4 mt-3 mt-lg-0 input-wrapper">
        <ejs-numerictextbox format='n2' decimals="2" formControlName="basePricePerDay" name='basePricePerDay' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
        <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[subscriptionForm.controls.currency.value] | translate}}</span>
        <app-error-messages [control]="subscriptionForm.controls.basePricePerDay"></app-error-messages>
      </div>
    </div>
  </div> -->
</div>
